import React, { FunctionComponent, Fragment, memo } from 'react';
import { useRouter } from 'next/router';
import { stringify } from 'query-string';

import Paginate from '@views/components/pagination';
import Block from '@views/components/block/Block';
import HeaderOrder from './components/header';
import ProductList from './components/product-list';
import EmptyState from './components/empty-state';
import Placeholder from './placeholder';
import Recommend from '@views/modules/recommend/dynamic';

import {
  OrderType,
  // PAGE_SIZE
} from './const';
import { useProductList } from '../../hooks/use-product-list-by-category';

const PAGE_SIZE = 42;
import { INTERNAL_URI, INTERNAL_ROUTES } from '@helpers/route';
import _arrayToString from '@helpers/array-to-string';
import _scrollToTop from '@helpers/scroll-top';
import _getId from '@helpers/get-id-from-slug';

const HARD_CATE_ID = 401;

export const Container: FunctionComponent<any> = () => {
  const router = useRouter();
  const categoryId = _getId(router.query.slug);
  const page = parseInt(_arrayToString(router.query.page) || '1');
  const initialPage = page - 1;
  const defaultOrder = categoryId === HARD_CATE_ID ? OrderType.POPULAR : OrderType.BEST_SELLER
  const orderBy = _arrayToString(router.query.orderBy) || defaultOrder;

  const { products, page: pageResponse, loading, error } = useProductList({
    categoryId,
    page,
    limit: PAGE_SIZE,
    orderBy,
  });

  if (loading || error) {
    return <Placeholder />;
  }

  let totalPage = 0;
  if (pageResponse) {
    const total = pageResponse.get('total') || 0;
    totalPage = Math.ceil(total / PAGE_SIZE);
  }

  const clientRedirect = (query: any) => {
    _scrollToTop();

    const queryEncode = stringify(query, { encode: true });
    const uri = `${INTERNAL_ROUTES.CATEGORY}/${router.query.slug}?${queryEncode}`;

    router.push(
      {
        query,
        pathname: INTERNAL_URI.CATEGORY,
      },
      uri
    );
  };

  const handlePageClick = ({ selected }) => {
    const query = {
      page: selected + 1,
      orderBy,
    };

    clientRedirect(query);
  };

  const handleOrderClick = (params: any) => {
    const query = {
      page: 1,
      ...params,
    };

    clientRedirect(query);
  };

  const hrefBuilder = (pageIndex: string | number) => {
    const queryEncode = stringify(
      {
        page: pageIndex,
        orderBy,
      },
      { encode: true }
    );

    return `${INTERNAL_ROUTES.CATEGORY}/${router.query.slug}?${queryEncode}`;
  };

  return (
    <Block>
      <HeaderOrder activeOrder={orderBy} onFilter={handleOrderClick} />

      {totalPage === 0 ? (
        <Fragment>
          <EmptyState />
          <Recommend />
        </Fragment>
      ) : (
        <Fragment>
          <ProductList data={products} />

          <Paginate
            key={`${orderBy}-${page}`}
            initialPage={initialPage}
            pageCount={totalPage}
            onPageChange={handlePageClick}
            hrefBuilder={hrefBuilder}
          />
        </Fragment>
      )}
    </Block>
  );
};

export default memo(Container);
